'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.consentToProcessFailed = exports.consentToProcessSucceeded = exports.clickedConsentToProcess = undefined;
exports.consentToProcess = consentToProcess;

var _reduxActions = require('redux-actions');

var _prospectUtkSelectors = require('../../selectors/prospectUtkSelectors');

var _ActionTypes = require('../constants/ActionTypes');

var _getSessionId = require('../../selectors/widgetDataSelectors/getSessionId');

var _getMessageId = require('../../selectors/widgetDataSelectors/getMessageId');

var _ConsentToProcessClient = require('../client/ConsentToProcessClient');

var _handleStoreMessagesCookie = require('../../post-message/actions/handleStoreMessagesCookie');

var clickedConsentToProcess = exports.clickedConsentToProcess = (0, _reduxActions.createAction)(_ActionTypes.CONSENT_TO_PROCESS);
var consentToProcessSucceeded = exports.consentToProcessSucceeded = (0, _reduxActions.createAction)(_ActionTypes.CONSENT_TO_PROCESS_SUCCEEDED);
var consentToProcessFailed = exports.consentToProcessFailed = (0, _reduxActions.createAction)(_ActionTypes.CONSENT_TO_PROCESS_FAILED);

function consentToProcess() {
  return function (dispatch, getState) {
    var sessionId = (0, _getSessionId.getSessionId)(getState());
    var welcomeMessageId = (0, _getMessageId.getMessageId)(getState());

    dispatch(clickedConsentToProcess());

    (0, _ConsentToProcessClient.sendConsentToProcess)({ sessionId: sessionId, welcomeMessageId: welcomeMessageId }).then(function () {
      dispatch((0, _handleStoreMessagesCookie.handleStoreMessagesCookie)((0, _prospectUtkSelectors.getMessagesUtk)(getState())));
      dispatch(consentToProcessSucceeded());
    }, function () {
      return dispatch(consentToProcessFailed());
    }).done();
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/gdpr/actions/visitorConsentsToProcess.js
// module id = 165
// module chunks = 2 3